{
  "version": 1,
  "asset_id": "77905f93-4da6-497d-a19f-eb1c7ba4b73d",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/77905f93-4da6-497d-a19f-eb1c7ba4b73d/stamped-antique-restore.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/77905f93-4da6-497d-a19f-eb1c7ba4b73d/stamped-antique-restore.webp",
  "original_filename": "stamped-antique-restore.webp",
  "size": 89244,
  "content_type": "image/webp",
  "created_at": "2026-08-16T22:26:28Z"
}
